import { MdOutlineFileDownloadDone } from "react-icons/md";
import { useContext } from "react";
import { TaskContext } from "../context/ContextTask";
import { FcApproval, FcHighPriority } from "react-icons/fc";
import { FaTrash} from "react-icons/fa";

function TaskCard({ task }) {
  const { deleteTask, putTask } = useContext(TaskContext);
  const handleDelete = (id) => deleteTask(id);
  const handleUpdate = (id, done) => putTask(id, done);
  return (
      <div className="card col-lg-6 col-xl-4 p-2 border-0 shadow mb-1">
        <div
          className={`card-header rounded  ${task.done ? "bg-success" : "bg-danger"}`}
        >
          <div className="position-relative pb-1">
            <div className="text-light">Titulo :</div>
            <div className="text-light mt-1">{task.title}</div>
            <button
              className="btn btn-info btn-sm position-absolute top-0 end-0"
              onClick={() => handleDelete(task._id)}
            >
              <FaTrash size={20} color={"purple"}/>
            </button>
          </div>
        </div>
        <div className="card-body bg-light position-relative">
          <div className="card-text fs-4"> Detalles </div>
          <p className="card-text fs-5">{task.description}</p>
          <p className="card-text fs-4">
            {" "}
            Estado : {task.done ? <FcApproval  size={25} /> : <FcHighPriority size={25} color={"red"} />}
          </p>
          <div>
            <button
              className="btn btn-success shadow btn-sm position-absolute bottom-0 end-0 me-2 mb-2"
              onClick={() => handleUpdate(task._id, task.done)}
            >
              <MdOutlineFileDownloadDone size={20}/>
            </button>
          </div>
        </div>
      </div>
  );
}

export default TaskCard;
